import { Route } from '@/router/types'
export const queueRoutes: Route[] = [
  {
    path: '/my-queue',
    name: '#myQueue',
    component: () => import('@/legacy/pages/MyQueue.vue'),
    meta: {
      title: 'My Queue',
      permissionCheck: null,
    },
  },
  {
    path: '/enrollment-queue',
    name: '#enrollmentQueue',
    component: () => import('@/legacy/pages/EnrollmentQueue.vue'),
    meta: {
      title: 'Enrollment Queue',
      permissionCheck: 'canViewEnrollmentQueue',
    },
  },
  {
    path: '/omaat-enrollment-queue',
    name: '#omaatEnrollmentQueue',
    component: () =>
      import('@/pages/OmaatEnrollmentQueue/OmaatEnrollmentQueue.vue'),
    meta: {
      title: 'OMAAT Enrollment Queue',
      permissionCheck: 'canViewOmaatEnrollmentQueue',
    },
  },
  {
    path: '/pod-lead-queue',
    name: '#podLeadQueue',
    component: () => import('@/legacy/pages/PodLeadQueue.vue'),
    meta: {
      title: 'Pod Lead Queue',
      permissionCheck: 'canViewPagePodLeadQueue',
    },
  },
  {
    path: '/enrollment-lead-queue',
    name: '#enrollmentLeadQueue',
    component: () => import('@/legacy/pages/EnrollmentLeadQueue.vue'),
    meta: {
      title: 'Enrollment Lead Queue',
      permissionCheck: 'canViewPageEnrollmentLeadQueue',
    },
  },
  {
    path: '/tasks/all-tasks',
    name: '#allTasks',
    alias: ['/reminders/all-reminders', '/reminders/all-tasks'],
    component: () => import('@/legacy/pages/AllTasks.vue'),
    meta: {
      title: 'All Tasks',
      permissionCheck: 'canViewPageAllTasks',
    },
  },
  {
    path: '/admin/queue',
    name: '#adminQueue',
    component: () => import('@/pages/Admin/AdminQueue/AdminQueue.vue'),
    meta: {
      title: 'Admin Queue',
      permissionCheck: 'canViewAdminUserQueue',
    },
  },
  {
    path: '/scheduled-calls',
    name: '#scheduledCalls',
    component: () =>
      import('@/legacy/pages/ScheduledCallsQueue/ScheduledCallsQueue.vue'),
    meta: {
      title: 'Scheduled Calls',
      permissionCheck: 'canViewScheduledCallsQueue',
    },
  },
]
